import { Link } from "@/src/lib/next-compat";
import { useSearchParams } from "react-router-dom";

export default function CheckoutErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason");
  const code = searchParams.get("code");

  return (
    <main className="min-h-screen bg-[var(--background)] px-4 py-16">
      <div className="mx-auto max-w-md text-center">
        <h1 className="text-2xl font-semibold text-[var(--foreground)]">Payment could not be completed</h1>
        <p className="mt-3 text-sm text-[var(--muted-foreground)]">
          {reason === "cancelled"
            ? "You cancelled the payment, so nothing was charged. You can start again whenever you are ready."
            : reason === "declined"
              ? "Your payment was declined. Please try again or use another payment method."
              : reason === "hash" || reason === "amount"
                ? "We could not confirm this payment with the payment provider. If money left your account, contact support and we will sort it out."
                : reason === "transaction"
                  ? "We could not match this payment to your account."
                  : reason === "missing_resource"
                    ? "The payment provider did not return a result. Please try again."
                    : reason === "server"
                      ? "Something crashed while confirming the payment. Check server logs; your bank may still show a hold."
                      : "Something went wrong processing the payment. You have not been charged."}
        </p>
        {code ? (
          <p className="mt-2 font-mono text-xs text-[var(--muted-foreground)]">Code: {code}</p>
        ) : null}
        <Link
          to="/courses"
          className="mt-8 inline-block rounded-lg bg-[var(--primary)] px-5 py-2.5 text-sm font-medium text-[var(--primary-foreground)]"
        >
          Back to courses
        </Link>
      </div>
    </main>
  );
}
